import type { OrderStatus } from '../../types/Order';

/** Feed transport (the only thing that changes when the API gains a realtime channel). */
export const POLL_MS = 10_000;
export const OFFLINE_AFTER_FAILURES = 3;

/** Ticket timer thresholds for New and Accepted orders, in minutes. Later a location setting. */
export const WARN_AFTER_MIN = 5;
export const LATE_AFTER_MIN = 10;

/** An order stays "unseen" until acted on, opened, or half visible this long with the tab focused. */
export const UNSEEN_VISIBLE_MS = 5_000;
/** While a New order is unseen for longer than REPEAT_AFTER_MS the chime repeats at this interval. */
export const REPEAT_AFTER_MS = 60_000;
export const REPEAT_CHIME_MS = 30_000;

/** Board columns, left to right. */
export const BOARD_STATUSES = ['pending', 'accepted', 'preparing', 'ready'] as const satisfies readonly OrderStatus[];
export type BoardStatus = (typeof BOARD_STATUSES)[number];

/** More item lines than this collapse to COLLAPSED_LINES plus a "+N more" button. */
export const MAX_LINES = 6;
export const COLLAPSED_LINES = 5;

export const HISTORY_PAGE_SIZE = 25;

/** The board is four columns from this width (Tailwind `lg`); below it the columns are tabs and tickets cannot be dragged. */
export const COLUMNS_QUERY = '(min-width: 1024px)';

export type OrdersLayout = 'board' | 'table';
export type TypeFilter = 'all' | 'table' | 'togo';
export const layoutKey = (userId: string) => `qo.orders.view.${userId}`;
